module.exports = __webpack_public_path__ + "static/media/SCBForeign.358672a6.svg";